module.exports = __webpack_public_path__ + "static/media/foreign-language-delhi.e95b7eb0.jpg";